var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _text, _text2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 34,
    viewBox: "0 0 111 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 33,
    rx: 5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 32,
    rx: 4.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5L10 25.5L20 17Z",
    fill: "url(#playGrad1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5L20 17L14 23L10 25.5Z",
    fill: "url(#playGrad2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5L20 17L14 11L10 8.5Z",
    fill: "url(#playGrad3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17L24 19.5L14 23Z",
    fill: "url(#playGrad4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17L24 14.5L14 11Z",
    fill: "url(#playGrad5)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 29,
    y: 14,
    fontFamily: "-apple-system, Helvetica Neue, Arial, sans-serif",
    fontSize: 8,
    fill: "white",
    letterSpacing: 0.5
  }, "GET IT ON")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 29,
    y: 27,
    fontFamily: "-apple-system, Helvetica Neue, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "white"
  }, "Google Play")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playGrad1",
    x1: 10,
    y1: 17,
    x2: 20,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00B4D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playGrad2",
    x1: 10,
    y1: 17,
    x2: 20,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#69F0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playGrad3",
    x1: 10,
    y1: 8,
    x2: 20,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAB40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playGrad4",
    x1: 14,
    y1: 17,
    x2: 24,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E91E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playGrad5",
    x1: 14,
    y1: 11,
    x2: 24,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE57F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.6dd996f935da45f18401dd97ce98468c.svg";
export { ForwardRef as ReactComponent };